/*jshint esversion: 8 */
//{/* use this to comment inside jsx*/}
import './styles/home.css';
import './styles/aboutus.css';
import Image from 'react-bootstrap/Image';
import React, {useState, useEffect, useRef, useCallback} from 'react';
import { useNavigate } from 'react-router-dom';
import ab from './pix/mail.png';
import mp from './pix/arrow-right-1.png';
import l4 from './pix/l4.svg';
import gov from './pix/gov.jpg';
import chair from './pix/chair.jpg';
import Card from 'react-bootstrap/Card';
import proven from './pix/proven.jpg';
import prior from './pix/prior.jpg';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Navbar from 'react-bootstrap/Navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';


{/**logo should be png file, have a transparent background */}

/* ─── History slider data ─── */
const HISTORY_ITEMS = [
  { year: '1997', text: 'Founded Shereen with partner capital and began investing in hedge fund strategies' },
  { year: '2001', text: 'Opened to outside capital' },
  { year: '2005', text: 'Launched an "opportunistic" hedge fund strategy' },
  { year: '2009', text: 'Launched "recovery" hedge fund strategy' },
  { year: '2012', text: 'Launched direct investing private credit business' },
  { year: '2014', text: 'Launched additional direct investing credit funds in lending and CLOs' },
  { year: '2015', text: 'Launched a market neutral, multi-strategy platform with an open architecture, multi-PM model; branded business line as Shereen Summit Strategies' },
  { year: '2017', text: 'Exited original fund of hedge fund business after 20 successful years' },
  { year: '2018', text: 'Launched new direct investing private credit funds focused on private equity fund financing and European opportunities' },
  { year: '2020', text: 'Launched insurance business and exited CLO business' },
  { year: '2021', text: "Launched Shereen Summit's packaged alpha plus equity index exposure solution" },
  { year: '2023', text: 'Targeted launch of "enhanced" Shereen Summit flagship fund' },
];

function Abt () {
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);
    const [aboutUsHover, setAboutUsHover] = useState(false);
    const [strategiesHover, setStrategiesHover] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        document.body.classList.toggle("menu-open", menuOpen);
        // Cleanup: make sure class is removed if the component unmounts
        // while the menu is open (e.g. route change).
        return () => {
            if (menuOpen) document.body.classList.remove("menu-open");
        };
    }, [menuOpen]);

    // Simple toggle for the hamburger button — no more manual DOM calls here.
    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    // Dedicated close function used by the X button, overlay, and nav items.
    const closeMenu = () => {
        setMenuOpen(false);
    };
    // Add these states for mobile dropdowns (separate from desktop)
    const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
    const [mobileStrategiesOpen, setMobileStrategiesOpen] = useState(false);
    // New State for Scroll Effect
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // If user scrolls more than 150px, trigger the fixed state
            if (window.scrollY > 150) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);


    /* ─── History Slider State ─── */
    const trackRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft]   = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(true);

    /* Update arrow enable/disable state whenever the track scrolls */
    const updateNavButtons = useCallback(() => {
        const track = trackRef.current;
        if (!track) return;
        setCanScrollLeft(track.scrollLeft > 2);
        setCanScrollRight(track.scrollLeft < track.scrollWidth - track.clientWidth - 2);
    }, []);

    useEffect(() => {
        const track = trackRef.current;
        if (!track) return;
        track.addEventListener('scroll', updateNavButtons, { passive: true });
        /* Run once on mount so the right arrow is enabled from the start */
        updateNavButtons();
        return () => track.removeEventListener('scroll', updateNavButtons);
    }, [updateNavButtons]);

    /**
     * Scroll the track by exactly one card width.
     * On mobile (< 768 px) that equals the full container width (100 %).
     * On desktop it equals ¼ of the container width plus the gap.
     */
    const scrollHistory = (direction) => {
        const track = trackRef.current;
        if (!track) return;

        const isMobile = window.innerWidth < 768;

        if (isMobile) {
            // Mobile: scroll by one full card width
            const cardWidth = track.clientWidth; /* 1 card = 100% */
            track.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
        } else {
            // Desktop: scroll by the visible viewport width (shows 4 new cards)
            const viewportWidth = track.clientWidth;
            track.scrollBy({ left: direction * viewportWidth, behavior: 'smooth' });
        }
    };


    return (
     <div class=''>

    <Navbar id='nav-ham' expanded={expanded} onToggle={() => setExpanded(!expanded)} collapseOnSelect expand="lg" fixed="top" className={`custom-navbar ${scrolled ? 'navbar-fixed-reveal' : ''}`} variant="light">
  <Container className="d-flex w-100 align-items-center justify-content-between" id='nav-con-f'>
  <Navbar.Brand href="/"><Image
                src={l4}
                id='nav-img-og'
                alt="shereen Logo"
            /></Navbar.Brand>

{/* Custom Hamburger Button for mobile */}
  <button
  id='burg'
  className={`hamburger-button ${menuOpen ? "active" : ""}`}
  onClick={toggleMenu}
  aria-label="Menu"
>
  <span className="hamburger-line"></span>
  <span className="hamburger-line"></span>
  <span className="hamburger-line"></span>
</button>

  <Navbar.Collapse id="responsive-navbar-nav" style = {{}}>
    <Nav className="ms-auto align-items-center"  style = {{marginRight: '-10%'}}  >
    <NavDropdown
                    title={
                        <span  onMouseEnter={() => setAboutUsHover(true)} onClick={(e) => {e.preventDefault(); navigate('/abt')}}
                        onMouseLeave={() => setAboutUsHover(false)} className="custom-span">
                            About Us <FontAwesomeIcon icon={faChevronDown}  className="dropdown-arrow ms-2" style = {{fontSize: '18px'}}/>
                        </span>
                    }
                    id="aboutus-dropdown"
                    className="nav-dropdown-custom"
                    show={aboutUsHover}
                >
                    <NavDropdown.Item onClick={() => navigate('/corporate-governance')}>
                        Corporate Governance
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => navigate('/chairmans-message')}>
                        Chairman's Message
                    </NavDropdown.Item>
                </NavDropdown>

      {/**SECOND NAV HOV */}
    <NavDropdown
    title={
        <span  onMouseEnter={() => setStrategiesHover(true)}
                onMouseLeave={() => setStrategiesHover(false)} className="custom-span">
            Our Strategies <FontAwesomeIcon icon={faChevronDown} style = {{fontSize: '18px'}} className="dropdown-arrow ms-2" />
        </span>
    }

    id="strategies-dropdown"
    className="nav-dropdown-custom"
    show={strategiesHover}
>
    <NavDropdown.Item onClick={() => navigate('/opportunities')}>
        Opportunistic Investing
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/lending')}>
        Direct Lending
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/liquidity-solutions')}>
        Fund Liquidity Solutions
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/corporate-finance')}>
        Corporate Financing
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/estate')}>
        Real Estate
    </NavDropdown.Item>
</NavDropdown>
      <Nav.Link id="nav-lks" onClick={() => navigate('/team')}>Our Team</Nav.Link>
      <Nav.Link id="nav-lks"  onClick={() => navigate('/careers')}>Careers</Nav.Link>
      <Nav.Link id="nav-lks"  onClick={() => navigate('/contact-us')}>Contact Us</Nav.Link>

    </Nav>

  </Navbar.Collapse>
  </Container>
</Navbar>

{/* ====================== CUSTOM MOBILE SLIDE MENU ====================== */}
{/* ====================== FULL SCREEN MOBILE SLIDE MENU ====================== */}
<div className={`mobile-menu-fullscreen ${menuOpen ? 'active' : ''}`}>
  <div className="mobile-menu-overlay" onClick={() => setMenuOpen(false)}></div>
  <div className="mobile-menu-container">
    <button className="mobile-menu-close" onClick={() => setMenuOpen(false)}>×</button>

    <div className="mobile-menu-content">
      <Nav className="flex-column mobile-nav-stack">

        {/* About Us with Dropdown */}
<div className="mobile-dropdown-wrapper">
<div className="mobile-menu-item" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
  <span
    className="mobile-menu-text"
    onClick={() => { navigate('/abt'); setMenuOpen(false); }}
    style={{ flex: 1, cursor: 'pointer' }}
  >
    About Us
  </span>
  <span
    className={`dropdown-arrow ${mobileAboutOpen ? 'open' : ''}`}
    onClick={() => setMobileAboutOpen(!mobileAboutOpen)}
    style={{ cursor: 'pointer', marginLeft:'20px'}}
  >
    ▼
  </span>
</div>
{mobileAboutOpen && (
  <div className="mobile-sub-menu">
    <div className="sub-item" onClick={() => { navigate('/corporate-governance'); setMenuOpen(false); }}>
      Corporate Governance
    </div>
    <div className="sub-item" onClick={() => { navigate('/chairmans-message'); setMenuOpen(false); }}>
      Chairman's Message
    </div>
  </div>
)}
</div>

        {/* Our Strategies with Dropdown */}
        <div className="mobile-dropdown-wrapper">
          <div
          className="mobile-menu-item"
          onClick={() => setMobileStrategiesOpen(!mobileStrategiesOpen)}
          style={{ justifyContent: 'space-between', alignItems: 'center' }}
        >
          <span style={{ flex: 1, cursor: 'pointer' }}>
            Our Strategies
          </span>
          <span className={`dropdown-arrow ${mobileStrategiesOpen ? 'open' : ''}`}>▼</span>
        </div>
          {mobileStrategiesOpen && (
            <div className="mobile-sub-menu">
              <div className="sub-item" onClick={() => { navigate('/opportunities'); setMenuOpen(false); }}>
                Opportunistic Investing
              </div>
              <div className="sub-item" onClick={() => { navigate('/lending'); setMenuOpen(false); }}>
                Direct Lending
              </div>
              <div className="sub-item" onClick={() => { navigate('/liquidity-solutions'); setMenuOpen(false); }}>
                Fund Liquidity Solutions
              </div>
              <div className="sub-item" onClick={() => { navigate('/corporate-finance'); setMenuOpen(false); }}>
                Corporate Financing
              </div>
              <div className="sub-item" onClick={() => { navigate('/estate'); setMenuOpen(false); }}>
                Real Estate
              </div>
            </div>
          )}
        </div>

        {/* Our Team */}
        <div className="mobile-menu-item" onClick={() => { navigate('/team'); setMenuOpen(false); }}>
          Our Team
        </div>

        {/* Careers */}
        <div className="mobile-menu-item" onClick={() => { navigate('/careers'); setMenuOpen(false); }}>
          Careers
        </div>

        {/* Contact Us */}
        <div className="mobile-menu-item no-border" onClick={() => { navigate('/contact-us'); setMenuOpen(false); }}>
          Contact Us
        </div>

      </Nav>
    </div>
  </div>
</div>

      {/**hero section start*/}
      <Container fluid className="px-0" style={{
        marginTop: '6%',
        paddingTop: '80px',
        paddingBottom: '80px',
        backgroundColor: '#CD1C18',
        color: '#ffffff',
        overflow: 'visible', // Allows the image to overlap the bottom edge
        position: 'relative',
        zIndex: 1
    }}>
            <Row    style = {{paddingLeft: '3%', paddingRight: '3%',}}>
            <Col md = {6} xs={12} id='sus-col-ch4'>
            <Row id='career-txt'><span id='career-bar-f'></span>About Us</Row>
            <Row id="cth">A Trusted Partner for Flexible Capital Solutions</Row>
          </Col>
          <Col id="borderr-ch" md = {4} style={{ position: 'relative', zIndex: 10, }}>
          <Image

              src={chair}
              style={{
                  width: '100%',
                  height: 'auto',
                  objectFit: 'cover',
                  position: 'relative',
                  zIndex: 1, // Image sits below the border lines
                  marginBottom: '-150px', // Pushes image into the next container
                  boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                  display: 'block'
              }}
              alt="Shereen Logo"
          />
      </Col>
            </Row>
       </Container>
       {/**hero section end*/}

       {/**utmost pride */}

       <Container  >
       <Row    style = {{marginTop: '100px', marginBottom: '100px'}}>
           <Col id = 'balance-col-ch4' md = {6} xs={12}>Shereen Investment Company LLC applies creativity and flexibility to offer alternative investment solutions that fit a range of capital needs.</Col>
       </Row>
      </Container>

       {/**chairman's message */}
       <Container fluid style = {{backgroundColor: '#f8f8f8'}}>
       <Row  id='tailored-rc'>

            <Row  id='flexible-row-opp-ch'>Diverse, Customized Solutions Providing Consistent Returns</Row>

            <Row>
             <Col  md = {5} xs={12} id='fortress-col'>
               <Row id='pf-f-row-ch' >Managing $18.8 billion*, Shereen Investment Company LLC provides proven creative solutions tailored to emerging companies and financial sponsors seeking growth capital and bridge financing in Middle East, Europe and Asia, as well as flexibility and capacity to lend. We also offer professional services in business development and investment consultancy across the board to private and public entities. Our core value proposition is to assist our clients in identifying new business and investment opportunities. Our specialized teams provide valuable services in helping clients to efficiently develop and implement their business and investment operations.</Row>
             </Col>
             <Col md = {5} xs={12} id='fortress-col'>
               <Row id='pf-f-row-ch'>Our diverse capital offerings range from senior-secured, unitranche and structured capital to specialty finance and niche real estate, providing liquid and illiquid solutions. Meanwhile, Shereen’s strategies aim to provide consistent risk-adjusted return. Shereen Investment Company LLC is excited to launch a new real estate finance program with a premier multi-billion dollar insurance company, in addition to its existing proprietary capital and fund investment platform. Shereen Investment Company LLC's new investment partner has allocated significant funds to invest in this strategy.</Row>
             </Col>
           </Row>

       </Row>
</Container>


      {/**Numbers*/}

      <Container fluid id='numbers-con-ch'>
            <Row  id='numbers-hd' >Numbers Speak to Our Success</Row>
            <Row id='numbers-row'>
                <Col md = {3} xs={12} id='numbers-txt' >
                    <Row className="justify-content-center align-items-center" style = {{color: '#b7944d', fontFamily: 'Lato', fontWeight: '900', fontSize: '60px', lineHeight: '84px',}}>$18.8B</Row>
                    <Row className="justify-content-center align-items-center" style = {{color: '#cd1c18', fontFamily: 'rufinaalt01', fontWeight: '400', fontSize: '22px', lineHeight: '25px'}}>Firm AUM</Row>
                    <Row className="justify-content-center align-items-center" style = {{color: '#cd1c18', fontFamily: 'rufinaalt01', fontWeight: '400', fontSize: '16px', lineHeight: '25px'}}>(as of June 31, 2025)</Row>
                </Col>
                <Col md = {3} xs={12} id='numbers-txt'>
                    <Row className="justify-content-center align-items-center" style = {{color: '#b7944d', fontFamily: 'Lato', fontWeight: '900', fontSize: '60px', lineHeight: '84px',}}>1997</Row>
                    <Row className="justify-content-center align-items-center" style = {{color: '#cd1c18', fontFamily: 'rufinaalt01', fontWeight: '400', fontSize: '22px', lineHeight: '25px'}}>Year founded</Row>
                </Col>
                <Col md = {3} xs={12} id='numbers-txt'>
                    <Row className="justify-content-center align-items-center" style = {{color: '#b7944d', fontFamily: 'Lato', fontWeight: '900', fontSize: '60px', lineHeight: '84px',}}>175+</Row>
                    <Row className="justify-content-center text-center" style = {{color: '#cd1c18', fontFamily: 'rufinaalt01', fontWeight: '400', fontSize: '22px', lineHeight: '25px'}}>Employees across five offices globally</Row>
                </Col>
                <Col md = {3} xs={12} id='numbers-txt-lt'>
                    <Row className="justify-content-center align-items-center" style = {{color: '#b7944d', fontFamily: 'Lato', fontWeight: '900', fontSize: '60px', lineHeight: '84px',}}>$15B+</Row>
                    <Row className="justify-content-center align-items-center text-center" style = {{color: '#cd1c18', fontFamily: 'rufinaalt01', fontWeight: '400', fontSize: '22px', lineHeight: '25px'}}>Deployed in 350+ transactions across credit strategies</Row>
                </Col>
            </Row>
      </Container>

            {/**PRIORITIZE ROW */}
            <Container id="prio-container" fluid style = {{backgroundColor: ''}}>
                      <Row  id="img-2-row-gch">
                          <Row>
                            <Col  id='f-col-13'>
                              <Row id='prio-hd' md = {5} xs={12} >We Prioritize Long-Term and Repeat Partnerships</Row>
                              <Row id='inw-24' md = {5} xs={12} >Shereen Investment Company LLC’s new loan program will continue to focus on small and middle-market real estate transactions with quality sponsors who have strong business plans. As a result of the new regulatory environment and increased capital requirements, traditional banks are in the midst of a secular change. Our new program is designed to offer flexibility, speed of execution and more responsiveness tailored to the specific needs of each borrower, a distinct advantage in this rapidly changing investment landscape.</Row>
                            </Col>

                            <Col  id="img-col-border-42-g" md = {5} xs={12}>
                                  <Image  id="img-2" src={prior}   alt="Data"/>
                            </Col>
                          </Row>
                      </Row>
             </Container>


             {/**EMPTY BAR */}
             <Container fluid >
                    <Row ><Col id='post-bar-ch'></Col></Row>
             </Container>



             {/**HISTORY SLIDER */}
             <Container fluid id='anim-bg'>
                    <Row id='anim-hd'>A History of Achievement</Row>

                    {/* ── Slider shell ── */}
                    <div className="hist-slider-shell">

                        {/* Left nav */}
                        <button
                            className={`hist-nav-btn hist-nav-left ${!canScrollLeft ? 'hist-nav-disabled' : ''}`}
                            onClick={() => scrollHistory(-1)}
                            disabled={!canScrollLeft}
                            aria-label="Previous"
                        >
                            &#8249;
                        </button>

                        {/* Scrollable track */}
                        <div className="hist-track" ref={trackRef}>
                            {HISTORY_ITEMS.map((item) => (
                                <div className="hist-card" key={item.year}>
                                    <div className="hist-card-year">{item.year}</div>
                                    <div className="hist-card-text">{item.text}</div>
                                </div>
                            ))}
                        </div>

                        {/* Right nav */}
                        <button
                            className={`hist-nav-btn hist-nav-right ${!canScrollRight ? 'hist-nav-disabled' : ''}`}
                            onClick={() => scrollHistory(1)}
                            disabled={!canScrollRight}
                            aria-label="Next"
                        >
                            &#8250;
                        </button>

                    </div>
             </Container>

      {/**proven */}
      <Container fluid  >
        <Row id="img-row-cc">
            <Col md = {5} xs={12} id="img-col-border-2-ch" ><Image id="img-2"  src={proven}   alt="Data"/></Col>
            <Col md = {5} xs={12} id='pro-rc-rw'>
                <Row id="proven-txt"  xs={12} >A Proven Record</Row>
                <Row id='proven-txt-tx'  xs={12} >On the investment side, Shereen Investment prioritizes a partnership culture that’s collaborative—arming our portfolio managers for success. On the lending side, we ensure that our portfolio company relationships are partnerships post-close, leading to continuity for the borrower. In this way, our relationships are non-adversarial, as our underwriting and portfolio management groups are the same.</Row>
            </Col>
        </Row>
      </Container>

      {/**end reach */}
<Container  fluid className="px-0">
<Row   style = {{marginTop: '1%'}}>
  {/* Card 1: Seeking Capital */}
  <Col lg={6} xs={12}>
      <Card
          className="cta-card"
          style={{
              backgroundColor: '#24325B',
              borderRadius: '0',
              border: 'none',
              height: '100%'
          }}
      >
          <Card.Body className="text-center py-5 px-4 px-md-5">
              <Image src={ab} style={{ height: '32px' }} alt="mail" />

              <h2 style={{
                  fontFamily: 'rufinaalt01',
                  fontWeight: '400',
                  fontSize: 'clamp(28px, 5.5vw, 48px)',
                  lineHeight: '1.15',
                  color: '#ffffff',
                  marginTop: '28px'
              }}>
                  Interested in Seeking Capital
              </h2>

              <p style={{
                  fontFamily: 'Lato',
                  fontWeight: '400',
                  fontSize: 'clamp(18px, 4vw, 24px)',
                  lineHeight: '1.45',
                  color: '#ffffff',
                  maxWidth: '580px',
                  margin: '24px auto 0'
              }}>
                  Contact us to learn how we apply creativity and flexibility to our capital solutions.
              </p>

              <div style={{ marginTop: '45px' }}>
                  <a
                      className="box"


                      onClick={(e) => {e.preventDefault(); navigate('/contact-us')}}
                      style={{
                          border: '1px solid #f7f5f0',
                          padding: '18px 24px',
                          display: 'inline-block',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          transition: 'all 0.4s ease'
                      }}
                  >
                      <Image src={mp} alt="arrow" style={{ width: '26px' }} />
                  </a>
              </div>
          </Card.Body>
      </Card>
  </Col>

  {/* Card 2: Join Our Team */}
  <Col lg={6} xs={12}>
      <Card
          className="cta-card"
          style={{
              backgroundColor: '#CD1C18',
              borderRadius: '0',
              border: 'none',
              height: '100%'
          }}
      >
          <Card.Body className="text-center py-5 px-4 px-md-5">
              <Image src={ab} style={{ height: '32px' }} alt="mail" />

              <h2 style={{
                  fontFamily: 'rufinaalt01',
                  fontWeight: '400',
                  fontSize: 'clamp(28px, 5.5vw, 48px)',
                  lineHeight: '1.15',
                  color: '#ffffff',
                  marginTop: '28px'
              }}>
                  Join Our Team
              </h2>

              <p style={{
                  fontFamily: 'Lato',
                  fontWeight: '400',
                  fontSize: 'clamp(18px, 4vw, 24px)',
                  lineHeight: '1.45',
                  color: '#ffffff',
                  maxWidth: '580px',
                  margin: '24px auto 0'
              }}>
                  Strong partnerships with customers start with the right colleagues.
              </p>

              <div style={{ marginTop: '45px' }}>
                  <a
                      className="box"

                      onClick={(e) => {e.preventDefault(); navigate('/careers')}}
                      style={{
                          border: '1px solid #f7f5f0',
                          padding: '18px 24px',
                          display: 'inline-block',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          transition: 'all 0.4s ease'
                      }}
                  >
                      <Image src={mp} alt="arrow" style={{ width: '26px' }} />
                  </a>
              </div>
          </Card.Body>
      </Card>
  </Col>
    </Row>
</Container>

            {/**footer section */}
            <Container  fluid style ={{backgroundColor: '#efefef', fontFamily: 'Lato',  paddingBottom: '10px'}}> {/**marginRight: '2%' */}


            <Row id='ft-txt'> © Copyright 2026 Shereen Investment Company LLC</Row>
                                    <Row id= 'last-rw' className='d-md-none m-0 p-0'>
            <Col id='linkd' xs={12} onClick={() => navigate('/')}><FontAwesomeIcon icon={faLinkedin} className="me-2" /></Col>
                  </Row>




    </Container>

            {/*the below div is last div/ function component div*/}
          </div>
    )
}

export default Abt;
